import React from 'react';
import BootstrapCarousel from './BootstrapCarousel';

const Service = () => {
  return (
    <div className="w-full min-h-screen pt-16">
      <BootstrapCarousel />
    </div>
  );
};

export default Service;